export class CustomerToken { 
    public address: number;
    public asccode: string;
    public break_end_time: string;
    public break_start_time: string;
    public currenttokens: string;
    public email: string;
    public end_time: string;
    public is_break_available: number;
    public name: string;
    public phone1: string;
    public phone2: string;
    public start_time: string;
    public languagaeid: number;
    public langcode: string;
}